/**
 * @generated SignedSource<<099668ff45d511c04fa995af0e116a2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ChangeEmailInput = {
  clientMutationId?: string | null;
  value: string;
};
export type ChangeEmailForm_ChangeEmailMutation$variables = {
  input: ChangeEmailInput;
};
export type ChangeEmailForm_ChangeEmailMutation$data = {
  readonly InfectopharmAuth: {
    readonly changeEmail: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type ChangeEmailForm_ChangeEmailMutation = {
  response: ChangeEmailForm_ChangeEmailMutation$data;
  variables: ChangeEmailForm_ChangeEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "InfectopharmAuthMutations",
    "kind": "LinkedField",
    "name": "InfectopharmAuth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "ChangeEmailPayload",
        "kind": "LinkedField",
        "name": "changeEmail",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangeEmailForm_ChangeEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangeEmailForm_ChangeEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a79142b28f4f88e33b149cb983e95540",
    "id": null,
    "metadata": {},
    "name": "ChangeEmailForm_ChangeEmailMutation",
    "operationKind": "mutation",
    "text": "mutation ChangeEmailForm_ChangeEmailMutation(\n  $input: ChangeEmailInput!\n) {\n  InfectopharmAuth {\n    changeEmail(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5796c84ce954feb6787ab82e0713fc2c";

export default node;
